module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"reload":"reload messages","filter scope":"filter scope","search":"Search","download":"download","dedicated for me":"dedicated for me"},"de":{"reload":"Nachrichten neu einlesen","filter scope":"Bereiche filtern","search":"Suche","download":"herunterladen","dedicated for me":"nur für mich"}}')
  delete Component.options._Ctor
}
